import React, { useEffect, useMemo, useState } from "react";
import RemarkTable from "./RmarksTable";

const AssetRemark = ({ data, path, from }) => {
  const [sortData, setSortedData] = useState([]);

  const filteredData = useMemo(() => {
    // Return empty array if data is missing or empty
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    // Filter by F_YEAR if provided and non-empty
    let yearChildren = [];
    if (path.F_YEAR && path.F_YEAR.trim() !== "") {
      const yearNode = data.find(
        (d) => (d.F_YEAR || "").trim() === path.F_YEAR.trim()
      );
      if (!yearNode) {
        return [];
      }
      yearChildren =
        yearNode.children && Array.isArray(yearNode.children)
          ? yearNode.children
          : [];
    } else {
      yearChildren = data.flatMap((d) =>
        d.children && Array.isArray(d.children) ? d.children : []
      );
    }

    // Filter by ASSET_GROUP if provided and non-empty
    let assetChildren = [];
    if (path.ASSET_GROUP && path.ASSET_GROUP.trim() !== "") {
      const assetGroupNode = yearChildren.find(
        (ag) =>
          (ag.ASSET_GROUP || "").trim().toLowerCase() ===
          path.ASSET_GROUP.trim().toLowerCase()
      );
      if (!assetGroupNode) {
        return [];
      }
      assetChildren =
        assetGroupNode.children && Array.isArray(assetGroupNode.children)
          ? assetGroupNode.children
          : [];
    } else {
      assetChildren = yearChildren.flatMap((ag) =>
        ag.children && Array.isArray(ag.children) ? ag.children : []
      );
    }

    // Filter by MAIN_CAUSE_DESC if provided and non-empty
    let mainCauseChildren = [];
    if (path.MAIN_CAUSE_DESC && path.MAIN_CAUSE_DESC.trim() !== "") {
      const mainCauseNode = assetChildren.find(
        (mc) =>
          (mc.MAIN_CAUSE_DESC || "").trim().toLowerCase() ===
          path.MAIN_CAUSE_DESC.trim().toLowerCase()
      );
      if (!mainCauseNode) {
        return [];
      }
      mainCauseChildren =
        mainCauseNode.children && Array.isArray(mainCauseNode.children)
          ? mainCauseNode.children
          : [];
    } else {
      mainCauseChildren = assetChildren.flatMap((mc) =>
        mc.children && Array.isArray(mc.children) ? mc.children : []
      );
    }

    // Filter by SUB_CAUSE_DESC if provided and non-empty
    let subCauseChildren = [];
    if (path.SUB_CAUSE_DESC && path.SUB_CAUSE_DESC.trim() !== "") {
      const subCauseNode = mainCauseChildren.find(
        (sc) =>
          (sc.SUB_CAUSE_DESC || "").trim().toLowerCase() ===
          path.SUB_CAUSE_DESC.trim().toLowerCase()
      );
      if (!subCauseNode) {
        return [];
      }
      subCauseChildren =
        subCauseNode.children && Array.isArray(subCauseNode.children)
          ? subCauseNode.children
          : [];
    } else {
      subCauseChildren = mainCauseChildren.flatMap((sc) =>
        sc.children && Array.isArray(sc.children) ? sc.children : []
      );
    }

    // Filter by Month if provided and non-empty
    if (path.Month && path.Month.trim() !== "") {
      const cleanMonth = path.Month.split(" ")[0].trim();
      const monthNode = subCauseChildren.find(
        (m) => (m.A_MONTH || "").trim() === cleanMonth
      );
      if (!monthNode) {
        return [];
      }
      return monthNode.data && Array.isArray(monthNode.data)
        ? monthNode.data
        : [];
    }

    // Return the final filtered data array
    return subCauseChildren.flatMap((m) =>
      m.data && Array.isArray(m.data) ? m.data : []
    );
  }, [
    data,
    path.F_YEAR,
    path.ASSET_GROUP,
    path.MAIN_CAUSE_DESC,
    path.SUB_CAUSE_DESC,
    path.Month,
  ]);

  useEffect(() => {
    if (filteredData && filteredData.length > 0) {
      // Sort by 9FAILUR_DATE_TIMEFROM (descending)
      const sorted = [...filteredData].sort((a, b) => {
        const dateA = new Date(a["9FAILUR_DATE_TIMEFROM"]);
        const dateB = new Date(b["9FAILUR_DATE_TIMEFROM"]);
        // Handle invalid dates
        if (isNaN(dateA.getTime())) return 1;
        if (isNaN(dateB.getTime())) return -1;
        return dateB.getTime() - dateA.getTime(); // Descending
      });

      // Apply SECTION_NAME filter if provided
      let result = sorted;
      if (path.SECTION_NAME && path.SECTION_NAME.trim() !== "") {
        result = sorted.filter(
          (item) =>
            (item.SECTION_NAME || "").trim().toLowerCase() ===
            path.SECTION_NAME.trim().toLowerCase()
        );
      }

      setSortedData(result);
    } else {
      setSortedData([]);
    }
  }, [filteredData, path]);

  return (
    <div className="newUiBody">
      {sortData.length === 0 ? (
        <p>No data matches the selected filters.</p>
      ) : (
        <div>
          <RemarkTable data={sortData} path={path} from={from} />
        </div>
      )}
    </div>
  );
};

export default AssetRemark;
